import { useQuery } from '@tanstack/react-query';
import { getUsersByRoleAndCityId } from 'api/requests/friends';

export const useGetUsersByRoleAndCityId = (role: string, cityId: string) => {
  return useQuery({
    queryKey: ['usersByRoleAndCityId', role, cityId],
    queryFn: () => getUsersByRoleAndCityId(role, cityId),
  });
};
